export { default } from './PathToSubmissionSkeleton';
